import Main from '../../../layouts/Isolated.vue';
import OrganisationLogin from '../views/OrganisationLogin.vue';

export default [
  {
    path: '/',
    name: 'loginModule',
    component: Main,
    children: [
      {
        path: 'login',
        name: 'organisationLogin',
        component: OrganisationLogin,
        title: 'TalentSensus',
        icon: 'fa-login'
      }
    ]
  }
];